import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const rootElement = document.getElementById("root");

// Choose between hydrateRoot and createRoot based on whether the pre-rendered
// HTML is a genuine react-snap tree (hydration-compatible) or a build-time
// stub emitted by generate-seo-pages.js. Both plain stubs (`data-ssg="true"`)
// and enriched stubs (`data-enriched-ssg="true"`) are semantic HTML for
// crawlers, not React renders — hydrating over them fires React error #418
// and falls back to a full render anyway. Explicit createRoot skips that
// noise. If neither marker is set the root is either empty (dev) or a real
// react-snap render (production with chromium), in which case we hydrate.
const isSsgStub =
  rootElement.dataset.ssg === 'true' ||
  rootElement.dataset.enrichedSsg === 'true';

if (rootElement.hasChildNodes() && !isSsgStub) {
  // Hydrate pre-rendered HTML from react-snap
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  // Client-side render: dev, empty #root, or SSG-stub replacement
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
